import { render, staticRenderFns } from "./floorsView.vue?vue&type=template&id=f705c642"
import script from "./floorsView.vue?vue&type=script&lang=js"
export * from "./floorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports